<template>
<tr>
    <td class="border-0" v-if="descriptionRequired">
        <input type="text" v-model="value.description" class="form-control" :placeholder="$t('booking.fields.lineDescription')"/>
        <small class="text-danger" v-if="errors['lines.' + index + '.description']">{{ errors['lines.' + index + '.description'][0] }}</small>
    </td>
    <td class="border-0">
        <div class="input-group">
            <input type="text" v-model="value.packages" class="form-control" :placeholder="$t('booking.fields.linePackage')"/>

            <div class="input-group-append">
                <b-dropdown :text=" value.unit.name" variant="outline-secondary">
                    <b-dropdown-item @click="value.unit = {code: 'PLL', name: $t('booking.unitTypes.PLL')}">{{ $t('booking.unitTypes.PLL') }}
                    </b-dropdown-item>
                    <b-dropdown-item @click="value.unit = {code: 'KLL', name: $t('booking.unitTypes.KLL')}">{{ $t('booking.unitTypes.KLL') }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <small class="text-danger" v-if="errors['lines.' + index + '.packages']">{{ errors['lines.' + index + '.packages'][0] }}</small>
    </td>
    <td class="border-0">
        <currency-input
            v-model="value.weight"
            class="form-control"
            :currency="null"
            :precision="3"
            :value-as-integer="true"
            :allow-negative="false"
        />
        <small class="text-danger" v-if="errors['lines.' + index + '.weight']">{{ errors['lines.' + index + '.weight'][0] }}</small>
    </td>
    <td class="border-0">
        <currency-input
            v-model="value.volume"
            class="form-control"
            :currency="null"
            :precision="3"
            :value-as-integer="true"
            :allow-negative="false"
        />
        <small class="text-danger" v-if="errors['lines.' + index + '.volume']">{{ errors['lines.' + index + '.volume'][0] }}</small>
    </td>
    <td class="border-0">
        <currency-input
            v-model="value.loading_meters"
            class="form-control"
            :currency="null"
            :precision="3"
            :value-as-integer="true"
            :allow-negative="false"
        />
        <small class="text-danger" v-if="errors['lines.' + index + '.loading_meters']">{{ errors['lines.' + index + '.loading_meters'][0] }}</small>
    </td>
    <td class="border-0" v-if="valueRequired">
        <div class="input-group">
            <currency-input
                v-model="value.value"
                class="form-control"
                :currency="null"
                :precision="2"
                :value-as-integer="true"
                :allow-negative="false"
            />
            <div class="input-group-append">
                <b-dropdown :text="value.value_currency" variant="outline-secondary">
                    <b-dropdown-item @click="value.value_currency = currency.currency_code" v-for="currency in currencies" :key="'currency' + currency.id">
                        {{ currency.currency_code }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>
        <small class="text-danger" v-if="errors['lines.' + index + '.value']">{{ errors['lines.' + index + '.value'][0] }}</small>
    </td>
    <td class="border-0 pr-0">
        <button class="btn btn-outline-danger" @click="remove">{{ $t('core.actions.remove') }}</button>
    </td>
</tr>
</template>

<script>

import { BDropdown, BDropdownItem } from 'bootstrap-vue'

export default {
    name: 'GoodsCreaditLine',
    components: {BDropdown,BDropdownItem},
    props: {
        value: {
            type: Object,
            required: true
        },
        errors: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        valueRequired: {
            type: Boolean,
            required: true
        },
        descriptionRequired: {
            type: Boolean,
            required: false,
            default: true
        },
        currencies: {
            type: Array,
            required: true
        }
    },
    methods: {
        remove(){
            this.$emit('remove', this.index);
        }
    }
}
</script>
